import { type Currency } from "../entities/Product";

export const DEFAULT_PRODUCT_CURRENCY = "pln";

export const DEFAULT_CURRENCY_OPTIONS: Currency[] = ["pln", "eur", "usd", "gbp"];
